import {
  FETCH_FIRST_SECTION,
  FETCH_FIRST_SECTION_SUCCESS,
  FETCH_FIRST_SECTION_FAIL,
  UPDATE_FIRST_SECTION,
  UPDATE_FIRST_SECTION_SUCCESS,
  UPDATE_FIRST_SECTION_FAIL,
} from "../actions/FirstSection";

const INITIAL_STATE = {
  firstSection: {},
  isSectionLoading: false,
  errorMessage: "",
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_FIRST_SECTION:
    case UPDATE_FIRST_SECTION:
      return { ...state, isSectionLoading: true };
    case FETCH_FIRST_SECTION_SUCCESS:
      return { ...state, isBlogLoading: false, firstSection: action.payload };
    case FETCH_FIRST_SECTION_FAIL:
      return { ...state, isBlogLoading: false, errorMessage: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/FirstSectionReducer.js